import { Locale, type LocalizedString } from "../Locale.js";
import type { Order } from "../Order.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/dekujeme-za-objednavku" as const,
	[Locale.en]: "/thank-you" as const,
} satisfies LocalizedString;

export function getOrderThankYouPath(locale: Locale, b2cDetailId?: Order["b2cDetailId"]): string {
	const path = getPathInLocale(locale, pathMap);
	return b2cDetailId ? `${path}?orderId=${b2cDetailId}` : path;
}
